import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const STATUS_LABELS = {
  draft: 'Kladde',
  sent: 'Sendt',
  paid: 'Betalt',
  cancelled: 'Annulleret'
};

const STATUS_COLORS = {
  draft: '#94a3b8',
  sent: '#3b82f6',
  paid: '#16a34a',
  cancelled: '#dc2626'
};

export default function Invoices() {
  const { apiFetch } = useAuth();
  const [invoices, setInvoices] = useState([]);
  const [filter, setFilter] = useState('all');
  const [error, setError] = useState('');

  useEffect(() => {
    apiFetch('/api/invoices').then(setInvoices).catch(err => setError(err.message));
  }, [apiFetch]);

  const filtered = filter === 'all'
    ? invoices
    : invoices.filter(i => i.status === filter);

  const totals = {
    all: invoices.length,
    draft: invoices.filter(i => i.status === 'draft').length,
    sent: invoices.filter(i => i.status === 'sent').length,
    paid: invoices.filter(i => i.status === 'paid').length,
  };

  return (
    <div>
      <div className="page-header">
        <h1>Fakturaer</h1>
        <Link to="/app/fakturaer/ny" className="btn btn-primary">+ Ny faktura</Link>
      </div>

      {error && <div className="alert alert-error" style={{marginBottom: '1rem'}}>{error}</div>}

      <div style={{display: 'flex', gap: '0.5rem', marginBottom: '1rem', flexWrap: 'wrap'}}>
        {[['all', 'Alle'], ['draft', 'Kladder'], ['sent', 'Sendt'], ['paid', 'Betalt']].map(([key, label]) => (
          <button key={key}
            className={`btn ${filter === key ? 'btn-primary' : 'btn-secondary'}`}
            style={{fontSize: '0.85rem', padding: '0.4rem 0.85rem'}}
            onClick={() => setFilter(key)}>
            {label} ({totals[key] || 0})
          </button>
        ))}
      </div>

      <div className="card">
        {filtered.length === 0 ? (
          <p style={{color: '#64748b', textAlign: 'center', padding: '2rem'}}>
            Ingen fakturaer endnu. Opret din første faktura!
          </p>
        ) : (
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Nr.</th>
                  <th>Dato</th>
                  <th>Modtager</th>
                  <th>Beløb</th>
                  <th>Forfald</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(inv => (
                  <tr key={inv.id}>
                    <td><strong>#{inv.invoice_number}</strong></td>
                    <td>{new Date(inv.date).toLocaleDateString('da-DK')}</td>
                    <td>{inv.recipient_name}</td>
                    <td style={{textAlign: 'right', fontWeight: 600}}>
                      {parseFloat(inv.total_amount).toLocaleString('da-DK', {minimumFractionDigits: 2})} kr.
                    </td>
                    <td>{new Date(inv.due_date).toLocaleDateString('da-DK')}</td>
                    <td>
                      <span style={{
                        display: 'inline-block', padding: '2px 10px', borderRadius: '12px',
                        fontSize: '0.8rem', fontWeight: 600,
                        background: STATUS_COLORS[inv.status] + '18',
                        color: STATUS_COLORS[inv.status]
                      }}>
                        {STATUS_LABELS[inv.status]}
                      </span>
                    </td>
                    <td className="text-right">
                      <Link to={`/app/fakturaer/${inv.id}`} className="btn btn-secondary btn-sm">Vis</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
